<template>
  <div class="Site PageBox">
    <van-nav-bar
      fixed
      :border="false"
      left-arrow
      @click-left="$router.push('/')"
      :right-text="$t('language')"
      @click-right="$router.push('/language')"
    />
    <div
      class="Login ScrollBox"
      :style="{
        backgroundImage: 'url(' + ((InitData.setting && InitData.setting.login_bg_img) || '') + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }"
    >
      <div
        style="
          width: 341px;
          height: 481px;
          margin: 8px auto;
          background: rgba(255, 255, 255, 0.15);
        /*  backdrop-filter: blur(12px);*/
          -webkit-backdrop-filter: blur(12px);
          border-radius: 16px;
          padding: 24px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        "
      ></div>
      <div
        class="Login-formWrap"
        style="
          z-index: 1000;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 310px;
        "
      >
        <!-- <div style="
          font-weight: 400;
          font-size: 35px;
          color: #FFFFFF;
          line-height: 56px;
          text-align: center;">VOISP</div> -->
        <van-form @submit="onSubmit" class="mt15" style="padding-top: 15px;">
          <van-field
            type="text"
            autocomplete="off"
            style="height: 0; width: 0; padding: 0; position: absolute"
          />
          <van-field
            type="password"
            autocomplete="off"
            style="height: 0; width: 0; padding: 0; position: absolute"
          />
          <van-field
            :border="false"
            left-icon="manager"
            :placeholder="$t('login.placeholder[0]')"
            size="large"
            autocomplete="off"
          >
            <template #input>
              <van-dropdown-menu>
                <van-dropdown-item 
                  v-model="areaCode" 
                  :options="areaOptions"
                  @change="onAreaCodeChange"
                />
              </van-dropdown-menu>
              <input
                type="tel"
                v-model.trim="postData.username"
                :placeholder="$t('register.placeholder[0]')"
                style="
                  border: 0;
                  flex: 1;
                  width: 100px;
                  padding-left: 50px;
                  background: transparent;
                  font-size: 12px;
                "
              />
            </template>
          </van-field>
          <van-field
            :border="false"
            v-model.trim="postData.password"
            :type="showPass ? 'text' : 'password'"
            left-icon="lock"
            :placeholder="$t('login.placeholder[1]')"
            size="large"
            clearable
            autocomplete="off"
            :right-icon="showPass ? 'eye' : 'closed-eye'"
            @click-right-icon="showPass = !showPass"
          />
          <!-- <van-field
              left-icon="coupon"
              v-model.trim="postData.code"
              autocomplete="off"
              type="digit"
              :placeholder="$t('register.placeholder[6]')"
              clearable
              :border="false"
              style="line-height: 2rem;"
            > 
              <template #button>
                <van-image width="100" height="30" :src="codeImg" style="display: block;cursor: pointer;" @click="getCode" />
              </template>
            </van-field> -->
          <van-cell size="large" :border="false">
            <van-checkbox
              v-model="keepUser"
              @change="changeKeepUser"
              checked-color="#37774C"
              icon-size="14"
              >{{ $t("login.text[0]") }}</van-checkbox
            >
          </van-cell>
          <van-cell size="large" :border="false" style="margin-top: -8px;">
            <van-checkbox
              v-model="agreePolicy"
              checked-color="#37774C"
              icon-size="14"
              style="vertical-align: middle;">
              <!-- 文字 + 链接 -->
              <span style="font-size: 14px; color:#fff;"  @click="openShow(InitData.yszc)">
                  {{ $t('login.serve[0]') }}
              </span>
            </van-checkbox>
          </van-cell>
          <div>
            <van-button
              size="large"
              round
              block
              :loading="isSubmit"
              :loading-text="$t('login.text[1]')"
              style="font-size: 18px; background-color: #37774C; border: 0"
              >{{ $t("login.text[2]") }}</van-button
            >
            <van-divider>or</van-divider>
            <van-button
              size="large"
              round
              :loading-text="$t('login.text[1]')"
              style="font-size: 18px; background-color: #37774C; border: 0"
              to="/register"
              >{{ $t("login.i18n[1]") }}</van-button
            >
            <!-- <i18n path="login.i18n[0]" tag="div" style="color: #999;margin-top: 30px;font-size: 1.6rem;">
                <template #title>{{docTitle}}</template>
                <router-link class="href" slot="a" to="/register">{{$t('login.i18n[1]')}}</router-link>
              </i18n> -->
          </div>
        </van-form>
      </div>
      <van-popup
	        v-model="showCon"
	        position="bottom"
	        closeable
	        close-on-popstate
	        class="policy-popup"
	        :style="{ width:'100%', height:'100vh' }"
	      >
	        <div class="policy-content ScrollBox">
	          <h3 class="policy-title">{{ infoData.title }}</h3>
	          <div class="policy-body" v-html="infoData.content"></div>
	        </div>
	      </van-popup>
    </div>
  </div>
</template>

<script>
import FacebookPixel from '@/utils/FacebookPixel'
export default {
  name: "Login",
  components: {},
  props: [],
  data() {
    return {
      postData: {
        username: localStorage["UserName"] || "",
        password: localStorage["PassWord"] || "",
        code: "",
      },
      keepUser: localStorage["KeepUser"] == "1" ? true : false,
      isSubmit: false,
      showPass: false,
      docTitle: document.title,
      areaOptions: [],
      areaCode: "",
      codeImg: "",
      agreePolicy: false,
      showCon: false,
      infoData:''
    };
  },
  computed: {},
  watch: {},
  created() {
    /* this.$Model.SmsCode((data) => {
      this.areaOptions = data.map(item => ({ text: item.name, value: item.id }))
      this.areaCode = data[0].id
    }) */
    const areaCode = this.InitData.setting && this.InitData.setting.area_code;
    const areaList = areaCode ? [areaCode] : [];
    this.areaOptions = areaList.map(item => ({ text: item, value: item }));
    this.areaCode = areaCode || '';
    this.getCode();
  },
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    openShow(data) {
	    this.showCon = true
	    this.infoData = data
	  },
    getCode() {
      this.postData.code_rand = new Date().getTime();
      //this.codeImg = this.ApiUrl+'/Account/code?code_rand='+this.postData.code_rand
      this.codeImg =
        "https://code.voisp.cc/api/Account/code?code_rand=" +
        this.postData.code_rand;
    },
    onSubmit() {
      if (!this.postData.username) {
        this.$Dialog.Toast(this.$t("login.placeholder[0]"));
        return;
      }
      if (!this.postData.password) {
        this.$Dialog.Toast(this.$t("login.placeholder[1]"));
        return;
      }
      this.isSubmit = true;
      FacebookPixel.trackCustomEvent("loginClick",{});
      this.$Model.Login(this.postData, (data) => {
        this.isSubmit = false;
        if (this.keepUser) {
          localStorage["UserName"] = this.postData.username;
          localStorage["PassWord"] = this.postData.password;
        } else {
          localStorage.removeItem("UserName");
          localStorage.removeItem("PassWord");
        }
        /* if(data.code==1){
          this.$parent.clearMiliao()
        } */
        //setTimeout(500)
        //this.$Model.GetBankCardList()
      });
    },
    changeKeepUser() {
      if (this.keepUser) {
        localStorage["KeepUser"] = 1;
      } else {
        localStorage.removeItem("KeepUser");
      }
    },
    onAreaCodeChange(value) {
      this.areaCode = value;
    },
  },
};
</script>
<style scoped>
.van-dropdown-menu {
  position: absolute;
  left: 0;
}
.van-dropdown-menu ::v-deep .van-dropdown-menu__bar {
  height: auto;
  box-shadow: none;
  background: transparent;
}
.van-dropdown-menu ::v-deep .van-dropdown-menu__title {
  padding: 0 10px 0 0;
  margin-right: 10px;
  color: #888;
  font-size: 12px;
}
.ScrollBox .van-form .van-field {
  background-color: #fff !important;
  border-radius: 0;
  box-shadow: none;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 0.65rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  border-radius: 8px;
}
.Login {
  position: relative;
  /* 为顶部背景图标预留空间，避免被登录卡片遮挡；自适应保证骑行图标完整显示 */
  padding-top: min(22vh, 220px);
  box-sizing: border-box;
}
.Login-formWrap {
  top: min(22vh, 220px);
}
.Login .href {
  color: #000;
}
.van-divider {
  color: #fff;
}
.policy-popup .van-popup__container {
  max-height: 100vh;
}
.policy-content {
  height: calc(100vh - 60px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 20px;
}
.policy-title {
  text-align: center;
  margin: 20px 0 10px;
  color: #333;
  font-size: 1.2rem;
}
.policy-body {
  text-align: justify;
  color: #333;
  line-height: 1.6;
}
</style>



       
